import { Component } from 'react';
import { Button } from 'components/common';

/**
 * Stops one broken view from blanking the whole app.
 *
 * public/index.html has an equivalent only inside v3RenderView, which try/catches
 * each V3 view and paints a "RENDER ERROR" panel with a retry. V1 and V2 have no
 * such guard at all — a throw there leaves the last render on screen with no
 * indication anything failed. This covers all three.
 */
export default class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[AppErrorBoundary]', error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="err-boundary">
        <div className="err-boundary__mark">⚠</div>
        <div className="err-boundary__title">
          RENDER ERROR{this.props.label ? ` — ${String(this.props.label).toUpperCase()}` : ''}
        </div>
        <div className="err-boundary__msg">{error.message}</div>
        <Button variant="outline" onClick={() => this.setState({ error: null })}>
          ↺ Retry
        </Button>
      </div>
    );
  }
}
